var map = {
	"./banks/bank-american-express.svg": 393,
	"./banks/bank-azlo.svg": 394,
	"./banks/bank-bank-america.svg": 395,
	"./banks/bank-brex.svg": 396,
	"./banks/bank-capital-one.svg": 397,
	"./banks/bank-chase.svg": 398,
	"./banks/bank-citi.svg": 399,
	"./banks/bank-danske-bank.svg": 400,
	"./banks/bank-first-republic.svg": 401,
	"./banks/bank-handelsbanken.svg": 402,
	"./banks/bank-ica.svg": 403,
	"./banks/bank-klarna.svg": 404,
	"./banks/bank-lansforsakringar.svg": 405,
	"./banks/bank-mercury.svg": 406,
	"./banks/bank-nordea.svg": 407,
	"./banks/bank-revolut.svg": 408,
	"./banks/bank-sbanken.svg": 409,
	"./banks/bank-seb.svg": 410,
	"./banks/bank-skandiabanken.svg": 411,
	"./banks/bank-svb.svg": 412,
	"./banks/bank-swedbank.svg": 413,
	"./banks/bank-us-bank.svg": 414,
	"./banks/bank-wells-fargo.svg": 415,
	"./categories/equipment.svg": 416,
	"./categories/investments-grants.svg": 417,
	"./categories/loans.svg": 418,
	"./categories/marketing.svg": 419,
	"./categories/meals-and-drinks.svg": 420,
	"./categories/money-in.svg": 421,
	"./categories/money-out.svg": 422,
	"./categories/office-costs.svg": 423,
	"./categories/other.svg": 424,
	"./categories/payroll-perks.svg": 425,
	"./categories/professional-services.svg": 426,
	"./categories/rent.svg": 427,
	"./categories/revenue.svg": 428,
	"./categories/software.svg": 429,
	"./categories/taxes.svg": 430,
	"./categories/travel.svg": 431,
	"./categories/utilities.svg": 432,
	"./logo.svg": 433,
	"./logo_alpha.svg": 434,
	"./logo_beta.svg": 435,
	"./logo_mark.svg": 436,
	"./logo_without_alpha.svg": 437,
	"./merchants/46elks.svg": 438,
	"./merchants/7-eleven.svg": 439,
	"./merchants/84codes.svg": 440,
	"./merchants/adobe.svg": 441,
	"./merchants/ahlens.svg": 442,
	"./merchants/airtable.svg": 443,
	"./merchants/akademibokhandeln.svg": 444,
	"./merchants/albacross.svg": 445,
	"./merchants/almi.svg": 446,
	"./merchants/amazon.svg": 447,
	"./merchants/amex.svg": 448,
	"./merchants/amplitude.svg": 449,
	"./merchants/and-frankly.svg": 450,
	"./merchants/apotek-hjartat.svg": 451,
	"./merchants/apoteket.svg": 452,
	"./merchants/apple.svg": 453,
	"./merchants/arlanda-express.svg": 454,
	"./merchants/asana.svg": 455,
	"./merchants/atlassian.svg": 456,
	"./merchants/avanza.svg": 457,
	"./merchants/avo.svg": 458,
	"./merchants/aws.svg": 459,
	"./merchants/azure.svg": 460,
	"./merchants/balsamiq.svg": 461,
	"./merchants/bankgirot.svg": 462,
	"./merchants/banking-circle.svg": 463,
	"./merchants/barrels-burgers.svg": 464,
	"./merchants/bastard-burgers.svg": 465,
	"./merchants/bauhaus.svg": 466,
	"./merchants/billecta.svg": 467,
	"./merchants/billogram.svg": 468,
	"./merchants/binero.svg": 469,
	"./merchants/bitrise.svg": 470,
	"./merchants/bogard.svg": 471,
	"./merchants/boknsok.svg": 472,
	"./merchants/bolagsverket.svg": 473,
	"./merchants/bolt.svg": 474,
	"./merchants/bonnier.svg": 475,
	"./merchants/bontouch.svg": 476,
	"./merchants/bookbeat.svg": 477,
	"./merchants/booking.svg": 478,
	"./merchants/braze.svg": 479,
	"./merchants/buffer.svg": 480,
	"./merchants/burger-king.svg": 481,
	"./merchants/calendly.svg": 482,
	"./merchants/canva.svg": 483,
	"./merchants/carta.svg": 484,
	"./merchants/chartmogul.svg": 485,
	"./merchants/circle-ci.svg": 486,
	"./merchants/circle-k.svg": 487,
	"./merchants/cisco.svg": 488,
	"./merchants/clas-ohlson.svg": 489,
	"./merchants/codeship.svg": 490,
	"./merchants/collector.svg": 491,
	"./merchants/cool-company.svg": 492,
	"./merchants/coop.svg": 493,
	"./merchants/csn.svg": 494,
	"./merchants/customer-io.svg": 495,
	"./merchants/cypress-io.svg": 496,
	"./merchants/danske-bank.svg": 497,
	"./merchants/dathost.svg": 498,
	"./merchants/dbt.svg": 499,
	"./merchants/detectify.svg": 500,
	"./merchants/dhl.svg": 501,
	"./merchants/digital-ocean.svg": 502,
	"./merchants/dnb.svg": 503,
	"./merchants/docker.svg": 504,
	"./merchants/docsend.svg": 505,
	"./merchants/docusign.svg": 506,
	"./merchants/dooer.svg": 507,
	"./merchants/dreams.svg": 508,
	"./merchants/dropbox.svg": 509,
	"./merchants/duolingo.svg": 510,
	"./merchants/easyjet.svg": 511,
	"./merchants/easypark.svg": 512,
	"./merchants/elastic-cloud.svg": 513,
	"./merchants/elasticsearch.svg": 514,
	"./merchants/elgiganten.svg": 515,
	"./merchants/embassy-house.svg": 516,
	"./merchants/epidemic-sounds.svg": 517,
	"./merchants/espresso-house.svg": 518,
	"./merchants/everhour.svg": 519,
	"./merchants/excalidraw.svg": 520,
	"./merchants/fabrique.svg": 521,
	"./merchants/facebook.svg": 522,
	"./merchants/factiva.svg": 523,
	"./merchants/fathom.svg": 524,
	"./merchants/fitness24.svg": 525,
	"./merchants/fiverr.svg": 526,
	"./merchants/fivetran.svg": 527,
	"./merchants/flygbussarna.svg": 528,
	"./merchants/folksam.svg": 529,
	"./merchants/fonts-com.svg": 530,
	"./merchants/foodora.svg": 531,
	"./merchants/fortnox.svg": 532,
	"./merchants/framer.svg": 533,
	"./merchants/freshbooks.svg": 534,
	"./merchants/frilans-finans.svg": 535,
	"./merchants/front.svg": 536,
	"./merchants/fullstory.svg": 537,
	"./merchants/gateau.svg": 538,
	"./merchants/gigapay.svg": 539,
	"./merchants/github.svg": 540,
	"./merchants/gitlab.svg": 541,
	"./merchants/gjensidige.svg": 542,
	"./merchants/gjensidigi.svg": 543,
	"./merchants/gmodstore.svg": 544,
	"./merchants/godaddy.svg": 545,
	"./merchants/godel.svg": 546,
	"./merchants/google-ads.svg": 547,
	"./merchants/google-cloud.svg": 548,
	"./merchants/google-data.svg": 549,
	"./merchants/gust.svg": 550,
	"./merchants/gusto.svg": 551,
	"./merchants/hallon.svg": 552,
	"./merchants/handelsbanken.svg": 553,
	"./merchants/harvest.svg": 554,
	"./merchants/heap.svg": 555,
	"./merchants/hedvig.svg": 556,
	"./merchants/hellosign.svg": 557,
	"./merchants/hemkop.svg": 558,
	"./merchants/hemtex.svg": 559,
	"./merchants/heroku.svg": 560,
	"./merchants/holy-greens.svg": 561,
	"./merchants/hotjar.svg": 562,
	"./merchants/hover.svg": 563,
	"./merchants/hsl.svg": 564,
	"./merchants/hubspot.svg": 565,
	"./merchants/ibm.svg": 566,
	"./merchants/ica.svg": 567,
	"./merchants/icons8.svg": 568,
	"./merchants/if.svg": 569,
	"./merchants/ikea.svg": 570,
	"./merchants/imagilabs.svg": 571,
	"./merchants/indesign.svg": 572,
	"./merchants/intercom.svg": 573,
	"./merchants/invision.svg": 574,
	"./merchants/itunes.svg": 575,
	"./merchants/izettle.svg": 576,
	"./merchants/jenkins.svg": 577,
	"./merchants/jetbrains.svg": 578,
	"./merchants/johan-nystrom.svg": 579,
	"./merchants/kickstarter.svg": 580,
	"./merchants/kivra.svg": 581,
	"./merchants/kjell-&-company.svg": 582,
	"./merchants/klarna.svg": 583,
	"./merchants/kpmg.svg": 584,
	"./merchants/lagerhaus.svg": 585,
	"./merchants/lansforsakringar.svg": 586,
	"./merchants/lastpass.svg": 587,
	"./merchants/leanplum.svg": 588,
	"./merchants/leetify.svg": 589,
	"./merchants/linear.svg": 590,
	"./merchants/linkedin.svg": 591,
	"./merchants/lizard-brain.svg": 592,
	"./merchants/logdna.svg": 593,
	"./merchants/logmein.svg": 594,
	"./merchants/looker.svg": 595,
	"./merchants/loopia.svg": 596,
	"./merchants/lufthansa.svg": 597,
	"./merchants/luminati.svg": 598,
	"./merchants/mailchimp.svg": 599,
	"./merchants/mailgun.svg": 600,
	"./merchants/max.svg": 601,
	"./merchants/mcdonalds.svg": 602,
	"./merchants/media-markt.svg": 603,
	"./merchants/medium.svg": 604,
	"./merchants/meetup.svg": 605,
	"./merchants/memmo.svg": 606,
	"./merchants/metabase.svg": 607,
	"./merchants/microsoft.svg": 608,
	"./merchants/miro.svg": 609,
	"./merchants/mixpanel.svg": 610,
	"./merchants/mongodb.svg": 611,
	"./merchants/namecheap.svg": 612,
	"./merchants/netflix.svg": 613,
	"./merchants/netonnet.svg": 614,
	"./merchants/new-relic.svg": 615,
	"./merchants/nextory.svg": 616,
	"./merchants/ngrok.svg": 617,
	"./merchants/nordea.svg": 618,
	"./merchants/norwegian-air.svg": 619,
	"./merchants/norwegian-bank.svg": 620,
	"./merchants/notion.svg": 621,
	"./merchants/nucleo.svg": 622,
	"./merchants/obvious.svg": 623,
	"./merchants/office-depot.svg": 624,
	"./merchants/okq8.svg": 625,
	"./merchants/origami.svg": 626,
	"./merchants/outreach.svg": 627,
	"./merchants/ownit.svg": 628,
	"./merchants/paddle.svg": 629,
	"./merchants/paypal.svg": 630,
	"./merchants/pilot.svg": 631,
	"./merchants/pipedrive.svg": 632,
	"./merchants/plantagen.svg": 633,
	"./merchants/plausible.svg": 634,
	"./merchants/playstation.svg": 635,
	"./merchants/pleo.svg": 636,
	"./merchants/pliance.svg": 637,
	"./merchants/postnord.svg": 638,
	"./merchants/preem.svg": 639,
	"./merchants/pressbyran.svg": 640,
	"./merchants/prezi.svg": 641,
	"./merchants/propel.svg": 642,
	"./merchants/qatar-air.svg": 643,
	"./merchants/quickbooks.svg": 644,
	"./merchants/red-flag.svg": 645,
	"./merchants/revolut.svg": 646,
	"./merchants/ryanair.svg": 647,
	"./merchants/sas.svg": 648,
	"./merchants/seb.svg": 649,
	"./merchants/segment.svg": 650,
	"./merchants/sendgrid.svg": 651,
	"./merchants/sentry.svg": 652,
	"./merchants/shipright.svg": 653,
	"./merchants/shopify.svg": 654,
	"./merchants/shutterstock.svg": 655,
	"./merchants/siemens.svg": 656,
	"./merchants/sj.svg": 657,
	"./merchants/skatteverket.svg": 658,
	"./merchants/sketch.svg": 659,
	"./merchants/skovik.svg": 660,
	"./merchants/skylight-io.svg": 661,
	"./merchants/skype.svg": 662,
	"./merchants/sl.svg": 663,
	"./merchants/slack.svg": 664,
	"./merchants/sleeknote.svg": 665,
	"./merchants/snapchat.svg": 666,
	"./merchants/snowflake.svg": 667,
	"./merchants/solarwinds.svg": 668,
	"./merchants/spotify.svg": 669,
	"./merchants/squarespace.svg": 670,
	"./merchants/stitch.svg": 671,
	"./merchants/storytel.svg": 672,
	"./merchants/strava.svg": 673,
	"./merchants/stripe.svg": 674,
	"./merchants/strivr.svg": 675,
	"./merchants/superhuman.svg": 676,
	"./merchants/supermetrics.svg": 677,
	"./merchants/svea.svg": 678,
	"./merchants/swedbank.svg": 679,
	"./merchants/swish.svg": 680,
	"./merchants/systembolaget.svg": 681,
	"./merchants/teamtailor.svg": 682,
	"./merchants/teemyco.svg": 683,
	"./merchants/tele2.svg": 684,
	"./merchants/telenor.svg": 685,
	"./merchants/telia.svg": 686,
	"./merchants/terraform.svg": 687,
	"./merchants/tier.svg": 688,
	"./merchants/tolve.svg": 689,
	"./merchants/transferwise.svg": 690,
	"./merchants/transport-styrelsen.svg": 691,
	"./merchants/travis.svg": 692,
	"./merchants/tre.svg": 693,
	"./merchants/trello.svg": 694,
	"./merchants/trimero.svg": 695,
	"./merchants/tripletex.svg": 696,
	"./merchants/twilio.svg": 697,
	"./merchants/typeform.svg": 698,
	"./merchants/uber.svg": 699,
	"./merchants/ups.svg": 700,
	"./merchants/upwork.svg": 701,
	"./merchants/vectorstock.svg": 702,
	"./merchants/vete-katten.svg": 703,
	"./merchants/vimla.svg": 704,
	"./merchants/vipps.svg": 705,
	"./merchants/visma.svg": 706,
	"./merchants/voi.svg": 707,
	"./merchants/vultr.svg": 708,
	"./merchants/webex.svg": 709,
	"./merchants/webflow.svg": 710,
	"./merchants/webhallen.svg": 711,
	"./merchants/wework.svg": 712,
	"./merchants/whimsical.svg": 713,
	"./merchants/willys.svg": 714,
	"./merchants/wix.svg": 715,
	"./merchants/wizz-air.svg": 716,
	"./merchants/wordpress.svg": 717,
	"./merchants/xero.svg": 718,
	"./merchants/zacco.svg": 719,
	"./merchants/zapier.svg": 720,
	"./merchants/zoho.svg": 721,
	"./merchants/zoom.svg": 722,
	"./obv-logo-large-text.svg": 198,
	"./obv-logo-small-text.svg": 199,
	"./topbar_logo.svg": 723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 392;